import { useState, useEffect } from "react";
import useAbort from "../../../../common/hooks/use-abort";
import OrderTransportingOrderForwardingListParams from "../../../../common/services/order/transporting-order/forwarding/list/order-transporting-order-forwarding-list-params";
import orderService from "../../../../common/services/order/order.service";
import OrderTransportingOrderForwardingList from "../../../../common/services/order/transporting-order/forwarding/list/order-transporting-order-forwarding-list";

type UseOrderDetailsForwardingProps = {
  transportingOrderId: string | undefined;
};

const useOrderDetailsForwarding = (params: UseOrderDetailsForwardingProps) => {
  const [forwardingId, setForwardingId] = useState("");
  const [consumerTaxiId, setConsumerTaxiId] = useState("");
  const [producerTaxiId, setProducerTaxiId] = useState("");

  const abortSignal = useAbort();

  useEffect(() => {
    if (!params.transportingOrderId) return;

    getForwardings();
  }, [params.transportingOrderId]);

  const getForwardings = () => {
    if (!params.transportingOrderId) {
      return;
    }

    const loadParams: OrderTransportingOrderForwardingListParams = {
      transportingOrderId: params.transportingOrderId,
    };

    orderService
      .getForwardingList(loadParams, abortSignal.signal)
      .then(handleForwardingResponse);
  };

  const handleForwardingResponse = (
    response: OrderTransportingOrderForwardingList,
  ) => {
    const lastForwardingIndex = response.data.length - 1;

    setForwardingId(response.data[lastForwardingIndex]?.id);
    setConsumerTaxiId(
      response.data[lastForwardingIndex]?.contract.consumerTaxiId,
    );
    setProducerTaxiId(
      response.data[lastForwardingIndex]?.contract.producerTaxiId,
    );
  };

  return {
    producerTaxiId,
    forwardingId,
    consumerTaxiId,
    setForwardingId,
    getForwardings,
  };
};

export default useOrderDetailsForwarding;
